import { render, staticRenderFns } from "./contractTemplate.vue?vue&type=template&id=5a80a588&scoped=true&"
import script from "./contractTemplate.vue?vue&type=script&lang=js&"
export * from "./contractTemplate.vue?vue&type=script&lang=js&"
import style0 from "./contractTemplate.vue?vue&type=style&index=0&id=5a80a588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80a588",
  null
  
)

export default component.exports